/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SearchPaymentRequests200ResponseInnerSupplier
 */
export interface SearchPaymentRequests200ResponseInnerSupplier {
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'accountType': SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchPaymentRequests200ResponseInnerSupplier
     */
    'companyName': string;
}

export const SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum = typeof SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum[keyof typeof SearchPaymentRequests200ResponseInnerSupplierAccountTypeEnum];


